import api from 'common/api';

export const getShipMovementAPI = (params: any) => api.get('/ship-movements/search', params);

export const DOWNLOAD_SHIP_MOVEMENT_EXCEL_API = '/ship-movements/downloadexcel';

export const DOWNLOAD_API = '/ship-movements/download';
